(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('instrument-view', {
            parent: 'entity',
            params: {screen: 'InstrumentView'},
            url: '/instrument-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.instrumentView.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/instrument-view/instrument-view.html',
                    controller: 'InstrumentViewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('instrumentView');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })

        .state('manage_instrument-edit', {
            parent: 'instrument-view',
            url: '/edit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/instrument-view/manage-instrument-dialog.html',
                    controller: 'ManageInstrumentController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	
                            	 entity: ['InstrumentView', 'GlobalValues', function(InstrumentView, GlobalValues) {
                                     return InstrumentView.get({id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })

        .state('manage-instrument-todolist', {
            parent: 'dashboard',
            url: '/manageInstrument',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/instrument-view/manage-instrument-dialog.html',
                    controller: 'ManageInstrumentController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('instrument-view', null, { reload: 'instrument-view' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })

        .state('manage-instrument-resubmit', {
            parent: 'dashboard',
            url: '/manageInstrumentEdit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/instrument-view/manage-instrument-dialog.html',
                    controller: 'ManageInstrumentController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('instrument-view', null, { reload: 'instrument-view' });
                }, function() {
                    $state.go('^');
                });
            }]
        })

          .state('instrument-auditLog', {
            parent: 'audit-log',
            url: '/manageInstrumentAuditLog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/instrument-view/manage-instrument-dialog.html',
                    controller: 'ManageInstrumentController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('instrument-view', null, { reload: 'instrument-view' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
        .state('manage-instrument-historyReport', {
            parent: 'history-report',
            url: '/manageInstrumentHistory',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/instrument-view/manage-instrument-dialog.html',
                    controller: 'ManageInstrumentController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('instrument-view', null, { reload: 'instrument-view' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
         
         };
    })();
